import { FunctionComponent, memo, SyntheticEvent } from 'react';
import { useYaMetrica } from '~frontend/provider/yametrica';
import { useTranslation } from 'react-i18next';
import { Case } from '~types';

import { useStatusGame } from '../hooks';
import ButtonsCase, { OpenCase } from './ButtonsCase';
import { useProfile } from '../../profile/hooks';

import { Link } from 'react-router-dom';
import _ from 'lodash';
import { AuthBlock } from '~frontend/components/AuthBlock';
import { FreeCaseV2Timer } from '../FreeCaseV2Timer';
import dayjs from 'dayjs';

interface IPlayButtonm {
  getCase: Case;
}

const PlayButton: FunctionComponent<IPlayButtonm> = memo(({ getCase }) => {
  const yametrica = useYaMetrica();
  const getProfile = useProfile();
  const [gameStatus] = useStatusGame();

  const reachGoal = (
    event: SyntheticEvent<HTMLElement>,
    { reachgoal } = event?.currentTarget?.dataset ||
      // eslint-disable-next-line no-unsafe-optional-chaining
      (event.target as HTMLElement)?.dataset,
  ) => {
    yametrica.reachGoal(reachgoal);
  };

  const { t } = useTranslation();

  return !getProfile ? (
    <div className="open-cases-btns-wrap">
      <AuthBlock />
      <div className="btn-demo-wrap">
        <OpenCase
          className={`btn-demo b-violet b-violet-blue demover-1 ${
            gameStatus && 'disabled'
          }`}
          data-type="demo"
          data-rar={getCase?.color}
        >
          {t('advantages-sign-in-play-demo')}
        </OpenCase>
        <div className="btns-shadow-2"></div>
      </div>
    </div>
  ) : !getCase?.isAccess ? (
    <div className="case-btns-wrap">
      <Link
        to="/pay"
        className="btn btn-sell btn-unlock"
        state={{ promoCode: _.get(_.first(getCase?.getPromoCodes), 'items') }}
      >
        <span className="text">{t('Unlock')}</span>
      </Link>
    </div>
  ) : getCase?.type === 7 &&
    getCase?.userFreeOpen < 1 &&
    getCase?.freeCaseV2minDeposit <= getProfile.deposit24Hour &&
    getProfile?.deposit24HourTtl > 0 ? (
    <div className="case-btns-wrap">
      <a className="btn btn-blue disabled" href="#">
        <FreeCaseV2Timer
          deposit24HourTtl={dayjs()
            .add(getProfile?.deposit24HourTtl, 'milliseconds')
            .format()}
        />
      </a>
    </div>
  ) : getCase?.type === 7 && getCase?.userFreeOpen < 1 ? (
    <div className="case-btns-wrap">
      <Link to="/pay" className="btn btn-sell btn-unlock">
        <span className="text">{t('Unlock')}</span>
      </Link>
    </div>
  ) : (
    <>
      <ButtonsCase />
      {[1, 2, 3].includes(gameStatus) && (
        <div className="case-btns-wrap">
          <a className="btn btn-blue disabled" href="#">
            <span className="icon material-icons" data-icon="loop" />
            <span>{t('Opening')}</span> 
          </a>
        </div>
      )}
    </>
  );
});

export { PlayButton };
